<template lang="html">

  <div class="login-view column-center"
    :style="`background:url(${getBackground}) center/cover no-repeat; background-size:cover`">
    <div class="container-login" :style="getStyles.bgbody">
      <form @submit.prevent="validation" style="box-shadow: rgba(5, 59, 102, 0.2) 0px 2px 12px 0px;background: white;"
        v-if="!!!getOwnlogin || getGodmodeStatus">
        <div class="contenedor-logo">
          <img :src="(!!getBrand.logoLogin) ? getBrand.logoLogin : getBrand.logocolor">
        </div>

        <h2 class="title-dato" :style="getStyles.colorbasic" v-html="$t('portal_tutorizacion')"></h2>
        <div class="texto">
          <p class="info-color">{{ $t('login.acceso') }}</p>
        </div>
        <div class="contenedor-input">
          <label for="usuario">{{ $t('email') }}</label>
          <input type="text" v-model="data.eUsuario" id="usuario" :hasContent="!!data.eUsuario"
            :style="getStyles.input_black">
        </div>
        <div class="contenedor-input" @mouseleave="view.revealPass = false">
          <label for="password">{{ $t('contrasena') }}</label>
          <input :type="view.revealPass ? 'text' : 'password'" v-model="data.ePassword" id="password"
            :hasContent="!!data.ePassword" :style="getStyles.input_black">
          <reveal class="revealPass" :isReveal="view.revealPass" :basic="true"></reveal>
          <i @click="view.revealPass = !view.revealPass" class="revealPass"></i>
          <a class="link lostPass" @click="view.showRecuperar = true" :style="getStyles.colorTextBlack">{{
            $t('he_perdido_contrasena') }}</a>
        </div>
        <div class="column-center">
          <button class="btn load-blue" :style="getStyles.solidPrimary" :disabled="!canSend" :loading="view.loading">{{
            $t('acceder') }}</button>
        </div>
      </form>
      <div class="contenedor-login-terceros" :style="ownstyles.popup" v-if="!!getOwnlogin && !!!getGodmodeStatus">
        <div class="contenedor-logo">
          <img :src="getLogoColor">
        </div>

        <h2 class="title-dato" :style="getStyles.colorbasic" v-html="$t('portal_tutorizacion')"></h2>
        <div class="texto">
          <p class="info-color" :style="getStyles.colorButton">{{ $t('login.acceso') }}</p>
          <p>{{ $t('login.intro') }}</p>
        </div>
        <a class="btn" @click="validarRecuperarEmail" :style="getStyles.solidPrimary"
          :href="getServer + '/AuthUniversidades/solicitudAcceso.aspx?portal=tutor'">{{ $t('acceder') }}</a>
      </div>
    </div>

    <div class="cover-popup -recuperar row-center" v-if="view.showRecuperar">

      <div class="popup" :style="ownstyles.popup">

        <a class="cerrar -small" @click="view.showRecuperar = false">✕</a>

        <div class="contenedor-input">
          <label for="">{{ $t('introducir_email') }}</label>
          <input type="text" :style="getStyles.input_black" v-model="emailRecuperar">
          <span class="error" v-if="showerror">{{ $t('email_mal_formado') }}</span>
        </div>

        <a class="btn" @click="validarRecuperarEmail" :style="getStyles.solidPrimary">{{ $t('recuperar_contrasena') }}</a>

      </div>

    </div>

  </div>
</template>

<script lang="js">


import { mapActions, mapGetters } from 'vuex';

import router from '@/router'

import reveal from '@/components/parts/icons/reveal'

export default {
  name: 'login',
  props: [],
  mounted() {
    if (location.search.includes('idPractica')) {
      window.sessionStorage.setItem('idPractica', location.search.split('=')[1]);
    }
  },
  data() {
    return {
      data: {
        eUsuario: '',
        ePassword: '',
        eAmbito: 'PrivadoTutor'
      },
      view: {
        revealPass: false,
        showRecuperar: false,
        loading: false
      },
      emailRecuperar: '',
      showerror: false
    }
  },
  components: {
    'reveal': reveal
  },
  methods: {
    ...mapActions(['login', 'recuerdoPass']),
    validation: function () {
      if (this.canSend) {
        this.view.loading = true;
        this.login(this.data).then(response => {
          this.view.loading = false;
        }).catch(e => {
          this.view.loading = false;
        });
      }
    },
    validarRecuperarEmail() {
      if (this.emailRecuperar.includes('@')) {
        this.recuerdoPass(this.emailRecuperar).then(r => {
          console.log(r);
          if (r) {
            this.emailRecuperar = '';
            this.view.showRecuperar = false;
          }
        });
      } else {
        this.showerror = true;
      }
    }
  },
  computed: {
    ...mapGetters([, 'getStyles', 'getLogoColor', 'basicColors', 'getBackground', 'getOwnlogin', 'getServer', 'getBrand', 'getGodmodeStatus', 'getLanguage']),
    ownstyles: function () {
      return {
        popup: {
          background: this.basicColors.white
        }
      }
    },
    canSend: function () {
      var can = (!!this.data.eUsuario && !!this.data.ePassword);
      return can;
    }
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/views/login.vue